/** Canonical plural catalog routes (MVP B). */

export function productsPath(): '/products' {
  return '/products';
}

/**
 * URL segment for a product: its id lowercased, with dots turned into hyphens (`sa214-2.6` → `sa214-2-6`), so a
 * CDN or static-file rule never mistakes the tail of the code for a file extension.
 */
export function productSlug(id: string): string {
  return id.toLowerCase().replace(/\./g, '-');
}

/** Product URL uses commercial code slug, e.g. `ja-112p-gr`. */
export function productPath(id: string): string {
  return `/products/${productSlug(id)}`;
}

/** Category URL uses English slug, e.g. `jablotron-100-plus` (falls back to id). */
export function categoryPath(categorySlugOrId: string): string {
  return `/categories/${categorySlugOrId}`;
}

/** Subcategory URL uses English slug within category, e.g. `detectors`. */
export function subcategoryPath(categorySlugOrId: string, subcategorySlugOrId: string): string {
  return `/categories/${categorySlugOrId}/${subcategorySlugOrId}`;
}

/** Infer category id from subcategory id (`1_0` → `1`) when categoryId is missing. */
export function categoryIdFromSubcategoryId(subcategoryId: string): string {
  const idx = subcategoryId.indexOf('_');

  return idx === -1 ? subcategoryId : subcategoryId.slice(0, idx);
}
